import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propBool, propShape, propStr, } from '../../../../../helpers/custom-prop-types';
import RegionsCheckboxes from './Custom/RegionsCheckBoxes';
import InputTitle from './InputTitle';
const SolutionRegion = (props) => {
    const { formFields, isRequired, label, name, nameOther, regions, tip } = props;
    return (_jsxs("div", Object.assign({ className: 'form form-solution' }, { children: [_jsx(InputTitle, { isRequired: isRequired, label: label, tip: tip }), _jsx(RegionsCheckboxes, { formFields: formFields, name: name, nameOther: nameOther, regions: regions })] })));
};
SolutionRegion.propTypes = {
    formFields: propShape().isRequired,
    isRequired: propBool(),
    label: propStr().isRequired,
    name: propStr().isRequired,
    nameOther: propStr().isRequired,
    regions: propArrayShape().isRequired,
    tip: propStr(),
};
SolutionRegion.defaultProps = {
    isRequired: false,
    tip: '',
};
export default SolutionRegion;
